import {Component, AfterViewInit, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import 'rxjs/Rx';
import {NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { MdInputModule } from '@angular/material';
import {__moduleName, CanDeactivateGuard} from '../../interfaces';

import { BaseService } from '../../shared/services/base.service';
import { DialogService } from '../../shared/services/dialog.service';
import { FormLabelComponent } from '../../components/form/label/label.component';
import { FormMessageComponent } from '../../components/form/message/message.component';


import { UserUrl } from '../../shared/urls/user.url';
import { Utility } from '../../common/utility';
import { AppConstants } from '../../shared/constants/constants';
import { AppMessages } from '../../shared/constants/messages';
import { CreatePasswordModel } from '../../models/user/create-password.model';

@Component({
  moduleId: __moduleName,
  selector: 'create-password',
  templateUrl: 'create-password.component.html',
})

export class CreatePasswordComponent implements OnInit, AfterViewInit {
  public createPassForm: FormGroup;
  public createPasswordModel = new CreatePasswordModel('', '', '');
  private userid: string;
  constructor(private formBuilder: FormBuilder,
              public utility: Utility,
              private activeRouter: ActivatedRoute,
              private router: Router,
              private baseService: BaseService,
              public dialogService: DialogService) {

  }

  ngOnInit() {
    this.createForm();
  }

  ngAfterViewInit() {
  }

  createForm(){
    this.userid = this.activeRouter.snapshot.params['id'];
    this.createPassForm = this.formBuilder.group({
      UserId: this.userid,
      SecurityCode: ['', [Validators.required]],
      NewPassword: ['', [Validators.required, this.isValidNewPassword]],
      ConfirmPassword: ['', [Validators.required, this.isValidRePassword]],
    });
  }

  isValidNewPassword (control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let newPass = group.controls['NewPassword'].value;
      // if (group.controls['OldPassword'].value === newPass) {
      //   return { 'newPassSameOldPass': true };
      // }
      let pattern = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*[!@#$%^&*()_+\d])[A-Za-z\d!@#$%^&*()_+]{8,128}$/;
      if (!pattern.test(newPass)) {
        return { 'invalidPassPolicy': true };
      }
    }
    return null;
  }

  isValidRePassword(control: AbstractControl) {
    const group = control.parent;
    if (group) {
      let rePass = group.controls['ConfirmPassword'].value;
      if (group.controls['NewPassword'].value !== rePass) {
        return { 'newPassNotMatchConfirmPass': true };
      }
    }
    return null;
  }

  resetFormData (ngForm) {
    ngForm.resetForm();
    this.createPassForm.reset();
  }

  onSubmit(ngForm) {
    if (this.createPassForm.dirty && this.createPassForm.valid) {
      let url = UserUrl.CREATE_PASSWORD;
      this.baseService.postData(url, this.createPassForm.value).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            var type = data['type']
            if(type=='InvalidSecurityCode')
            {
            //  this.resetFormData(ngForm);
              this.dialogService.openSuccessDialog({message: data.message});
            }
            else if(type=='ValidSecurityCode')
            {
              this.dialogService.openSuccessDialog({message: data.message});
              this.router.navigate(["/landing"]);
            }
          }
        },
          error => {
           /*const tmpErr = error.json();
           if (tmpErr) {
             this.dialogService.openSuccessDialog({message: tmpErr.message});
           }*/
        }
      );
    }
  }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/create-password/create-password.component.ts